export default __webpack_public_path__ + "static/media/dinner.8dcf824d.svg";